<template>
  <div class="bj-warp">
    <top-nav-menu>
      <div>
        <template v-for="item in menuList">
          <router-link
            v-if="item.target === 'self'"
            :class="['menu-item']"
            :key="item.name"
            :to="item.path"
            >{{ item.name }}</router-link
          >
          <a
            class="menu-item"
            v-else-if="item.target === 'blank'"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </template>
      </div>
    </top-nav-menu>
    <div class="main-section">
      <breadcrumb />
      <div class="main">
        <div class="left-menu">
          <div :class="['m-menu', { active: isMain }]" @click="toMain">
            <img
              v-if="isMain"
              class="m-menu-icon"
              src="@/assets/image/main-menu-act.png"
            />
            <img
              v-else
              class="m-menu-icon"
              src="@/assets/image/main-menu.png"
            />
            控制台
          </div>
          <Menu
            class="cc-menu"
            ref="Menu"
            :open-names="openName"
            :active-name="activeName"
            accordion
            @on-open-change="openChange"
          >
            <Submenu
              :name="item.name"
              v-for="item in leftMenu"
              :key="item.title"
            >
              <template slot="title">
                <img
                  v-if="openName[0] == item.name"
                  class="m-menu-icon"
                  :src="item.iconAct"
                />
                <img v-else class="m-menu-icon" :src="item.icon" />
                {{ item.title }}
              </template>
              <MenuItem
                :name="item2.name"
                v-for="item2 in item.children"
                :key="item2.title"
                :to="item2.path"
                >{{ item2.title }}</MenuItem
              >
            </Submenu>
          </Menu>
        </div>
        <div class="right">
          <router-view></router-view>
        </div>
      </div>
    </div>

    <div>
      <div class="foot-nav">
        <div class="foot-nav-warp">
          <a
            class="link"
            v-for="item in navList"
            :href="item.path"
            target="_blank"
            :key="item.name"
            >{{ item.name }}</a
          >
        </div>
      </div>
      <div class="foot-bar">
        <div class="foot-bar-warp">
          <div class="foot-section1">
            <div class="foot-section-text">
              域见未来（北京）科技有限公司
              <a style="color: #737577" target="_blank" href="http://beian.miit.gov.cn">京ICP备2020035975号</a>
            </div>
            <div class="foot-section-text">
              北京市 海淀区 白家疃尚水园 4号楼 8层 3单元 801
            </div>
            <div class="foot-section-text">
              域名投诉举报处理平台 电话:010-58813000 邮箱:service@cnnic.cn
            </div>
          </div>
          <div class="foot-section2">
            <div class="foot-section-text">客服、投诉电话： 400-076-3676</div>
            <div class="foot-section-text">客服、投诉邮箱： service@domainfuture.cn</div>
          </div>
          <div class="foot-section3">
            <div class="foot-section-text">
              互联网域名服务许可证:
              <a style="color: #737577" target="_blank" href="https://domain.miit.gov.cn/域名注册服务机构/互联网域名/域见未来（北京）科技有限公司">京D3-20220005</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import topNavMenu from "components/topNavMenu";
import breadcrumb from "components/breadcrumb";

export default {
  name: "layout",
  components: {
    topNavMenu,
    breadcrumb,
  },
  data() {
    return {
      menuList: [
        {
          name: "域名注册",
          path: "/index",
          target: "self",
        },
        {
          name: "关于我们",
          path: "http://www.domainfuture.cn/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.domainfuture.cn/contact_complex.aspx?nid=7",
          target: "blank",
        },
      ],
      navList: [
        {
          name: "关于我们",
          path: "http://www.domainfuture.cn/about_complex.aspx?nid=1",
          target: "blank",
        },
        {
          name: "联系我们",
          path: "http://www.domainfuture.cn/contact_complex.aspx?nid=7",
          target: "blank",
        },
      ],
      // 左侧导航栏
      openName: [],
      // 选中的导航栏
      activeName: "",
      leftMenu: [
        {
          title: "域名管理",
          icon: require("@/assets/image/l-domain-icon.png"),
          iconAct: require("@/assets/image/l-domain-icon-act.png"),
          name: "domain",
          children: [
            {
              title: "我的域名",
              name: "domain-myDomain",
              path: "/my/domain",
            },
            {
              title: "我的模板",
              name: "domain-myTemplate",
              path: "/my/template",
            },
            {
              title: "我的转出",
              name: "domain-transferout",
              path: "/my/transferout",
            },
            {
              title: "我的转入",
              name: "domain-transferin",
              path: "/my/transferin",
            },
            {
              title: "域名PUSH",
              name: "domain-push",
              path: "/my/push",
            },
            {
              title: "域名订单",
              name: "domain-order",
              path: "/my/order",
            },
          ],
        },
        {
          title: "资金管理",
          icon: require("@/assets/image/l-capitaldetails-icon.png"),
          iconAct: require("@/assets/image/l-capitaldetails-icon-act.png"),
          name: "finance",
          children: [
            {
              title: "账户信息",
              name: "finance-account",
              path: "/my/finance/account",
            },
            {
              title: "资金明细",
              name: "finance-capitaldetails",
              path: "/my/finance/capitaldetails/index",
            },
            // {
            //   title: "发票管理",
            //   name: "finance-invoice",
            //   path: "/my/invoice",
            // },
          ],
        },
        {
          title: "账户管理",
          icon: require("@/assets/image/l-user-icon.png"),
          iconAct: require("@/assets/image/l-user-icon-act.png"),
          name: "user",
          children: [
            {
              title: "个人资料",
              name: "user-account",
              path: "/my/user/",
            },
            {
              title: "安全中心",
              name: "user-security",
              path: "/my/user/security",
            },
            {
              title: "我的认证",
              name: "user-certified",
              path: "/my/user/certified",
            },
            {
              title: "站内信",
              name: "user-mail",
              path: "/my/user/mail",
            },
            {
              title: "登录日志",
              name: "user-journal",
              path: "/my/user/journal",
            },
          ],
        },
      ],
      // isMain: false,
    };
  },
  computed: {
    isMain() {
      return this.$route.name === "my";
    },
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          // if(val.name === "user"){
          //   this.isMain = true;
          // }else{
          //   this.isMain = false;
          this.openName = [val.meta.submenu];
          this.activeName = val.meta.menuItem;
          this.$nextTick(() => {
            this.$refs.Menu.updateOpened();
            this.$refs.Menu.updateActiveName();
          });
          // }
        }
      },
    },
  },
  methods: {
    toMain() {
      this.$router.push("/my");
    },
    openChange(event) {
      // 获取当前打开主菜单的所有子菜单
      if (event.length > 0) {
        const checkData = this.leftMenu.filter((o) => o.name === event[0]);
        // 防止重复跳转路由
        if (this.$route.path !== checkData[0].children[0].path) {
          this.$router.replace({ path: checkData[0].children[0].path });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.m-menu {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 14px 24px;
  width: 180px;
  height: 50px;
  font-size: 16px;
  font-weight: Bold;
  border-radius: 30px;
  margin: 0 auto 30px;
  cursor: pointer;
  color: #737577;
}
.m-menu-icon {
  width: 30px;
  height: 30px;
  margin-right: 20px;
}
.m-menu.active {
  // background-color: #3992e9;
  color: #fff;
}
.bj-warp {
  position: relative;
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .menu-item {
    color: #333;
    line-height: 60px;
    font-weight: 400;
    font-size: 14px;
    margin-right: 40px;
  }
}
.foot-nav {
  display: flex;
  align-items: center;
  background-color: #212225;
  height: 80px;
  border-top: 1px solid #ffffff1a;
  .foot-nav-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    //justify-content: space-between;
    .link {
      width: 120px;
      height: 45px;
      line-height: 45px;
      border-radius: 23px;
      // border: 1px solid #ffffff1a;
      text-align: center;
      font-size: 14px;
      color: #737577;
      // color: #cacaff;
      font-weight: 400;
    }
    .link.active {
      color: #f85936;
    }
  }
}
.foot-bar {
  background-color: #212225;
  border-top: 1px solid #ffffff1a;
  .foot-bar-warp {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding-top: 45px;
    padding-bottom: 36px;
    .foot-section-text {
      font-weight: 400;
      font-size: 14px;
      color: #737577;
      &:nth-child(n + 2) {
        margin-top: 15px;
      }
    }
    .foot-section2 {
      margin-left: 116px;
    }
    .foot-section3 {
      flex: 1;
      display: flex;
      justify-content: space-between;
      margin-left: 136px;
      .customer {
        margin-top: 21px;
        width: 110px;
        text-align: center;
        height: 35px;
        line-height: 35px;
        color: #fff;
        border: 1px solid #f85a36;
        cursor: pointer;
        background-color: #f85a36;
        border-radius: 46px;
      }
    }
  }
}
.main-section {
  flex: 1;
  padding-top: 80px;
  background-color: #151718;
}
.main {
  display: flex;
  width: 1200px;
  margin: 0 auto 80px;
  .left-menu {
    padding-top: 60px;
    width: 230px;
    // min-height: 600px;
    margin: 0 auto;
    background-color: #202224;
    align-self: self-start;
    border-radius: 6px;
  }
  .right {
    flex: 1;
    margin-left: 30px;
    box-sizing: border-box;
  }
}
::v-deep .cc-menu {
  width: 170px !important;
  background-color: transparent;
  margin: 0 auto;
  .ivu-menu-opened {
    padding-bottom: 30px;
    .ivu-menu-submenu-title {
      // background-color: #3992e9;
      color: #fff;
    }
  }
  .ivu-menu {
    background-color: #2c2e2f;
    border-radius: 6px;
  }
  .ivu-menu-item {
    &::before {
      content: "";
      display: inline-block;
      margin-right: 20px;
    }
    color: #fff;
    transition: all 0.3s;
  }
  .ivu-menu-item:hover {
    background-color: #f85a36;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .ivu-menu-submenu-title {
    display: flex;
    align-items: center;
    color: #737577;
    font-size: 16px;
    font-weight: bold;
    border-radius: 30px;
    margin-bottom: 20px;
    .ivu-icon-ios-arrow-down {
      display: none;
    }
  }
  .ivu-menu-item-active:not(.ivu-menu-submenu) {
    background: #f85a36;
    color: #fff;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    &::after {
      width: 0;
    }
  }
  &::after {
    width: 0;
  }
}
</style>
